import { ISetOwnerParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class SetWorkbooksOwnerRequest extends Request<ISetOwnerParams, IResult> {
  constructor(ids: string[], ownerId: string) {
    super('setWorkbooksOwner', {
      ids: ids,
      ownerId: ownerId
    });
  }
}
